// import.meta.glob auto-registers every Stimulus controller here. Identifier comes
// from the path: `foo/bar_controller.js` -> `foo--bar`, `baz_controller.js` -> `baz`.
import { application } from "./application"
import { registerControllers } from "stimulus-vite-helpers"

const controllers = import.meta.glob("./**/*_controller.js", { eager: true })
registerControllers(application, controllers)
